__turbopack_context__.v({
  "clearButton": "GlobalSearchInput-module__RNkeLq__clearButton",
  "dropdownBody": "GlobalSearchInput-module__RNkeLq__dropdownBody",
  "dropdownFooter": "GlobalSearchInput-module__RNkeLq__dropdownFooter",
  "field": "GlobalSearchInput-module__RNkeLq__field",
  "footerHint": "GlobalSearchInput-module__RNkeLq__footerHint",
  "footerLabel": "GlobalSearchInput-module__RNkeLq__footerLabel",
  "input": "GlobalSearchInput-module__RNkeLq__input",
  "inputWrapper": "GlobalSearchInput-module__RNkeLq__inputWrapper",
  "kbd": "GlobalSearchInput-module__RNkeLq__kbd",
  "popover": "GlobalSearchInput-module__RNkeLq__popover",
  "root": "GlobalSearchInput-module__RNkeLq__root",
  "searchIcon": "GlobalSearchInput-module__RNkeLq__searchIcon",
  "shortcutOverlay": "GlobalSearchInput-module__RNkeLq__shortcutOverlay",
});
